import { OrderDirection } from "@/constants/orderDirection";
import { z } from "zod";
import { ColumnIds } from "./-constants";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  sortColumn: z.enum([ColumnIds.name, ColumnIds.displayOrder]).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
